var map = {
	"./base_d_dark.svg": "720e",
	"./business_d_dark.svg": "09f9",
	"./premium_d_dark.svg": "8d78",
	"./vip_d_dark.svg": "1525",
	"./vip_gold_d_dark.svg": "6d8b8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b77f";